/*
 * @Description: 广告管理
 */
<template>
    <div id="ad-detail">
        <!-- 顶部header模块 -->
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- <router-link :to="{path: '/newPromition', query: {type: 'creative', action: 'add'}}"  class="header-button-primary"
                        >新建广告</router-link
                    > -->
                </div>
                <div class="header-row-right">
                    <!-- 预设日期按钮 -->
                    <c-date-picker
                        :startDay.sync="tableParams.startDay"
                        :endDay.sync="tableParams.endDay"
                        @change="getCampaignList"
                    />
                </div>
            </div>
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 搜索 -->
                    <Input
                        v-model="tableParams.keyword"
                        placeholder="搜索广告/ID"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getCampaignList(true)"
                        @on-click="getCampaignList(true)"
                    />
                    <Input
                        v-model="tableParams.publisherName"
                        placeholder="搜索账号名(邮箱)"
                        class="header-search"
                        icon="android-search"
                        @on-keydown.enter="getCampaignList(true)"
                        @on-click="getCampaignList(true)"
                    />
                    <Button @click="onClickDown" type="primary">下载</Button>

                    <!-- 批量操作 -->
                    <!-- <div v-else class="edit-box">
                        <div class="edit">
                            已选择{{ selectedCount }}项
                            <span class="close-btn" @click.stop="onReSelectedAll">
                                <Icon type="close" />
                            </span>
                        </div>
                        <Dropdown @on-click="onChangeBatchType" trigger="click">
                            <button class="header-button-ghost">
                                <span class="header-button-ghost-span">
                                    <span>批量编辑</span>
                                </span>
                                <i class="icon header-button-ghost-down"></i>
                            </button>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="(item, index) in BatchType" :name="item" :key="index">{{
                                    item
                                }}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div> -->
                </div>
                <div class="header-row-right">
                    <!-- 状态筛选 -->
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('status', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span">状态：{{ statusValue[tableParams.status] }}</span>
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in statusList"
                                :name="value.name"
                                :selected="value.name == tableParams.status"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>
                    <!-- 投放状态筛选 -->
                    <Dropdown trigger="click" @on-click="(val) => changeStatus('dropDownStatus', val)">
                        <button class="header-button-ghost">
                            <span class="header-button-ghost-span"
                                >投放状态：{{ dropdownStatusValue[tableParams.dropDownStatus] }}</span
                            >
                            <i class="icon header-button-ghost-down"></i>
                        </button>
                        <DropdownMenu slot="list">
                            <DropdownItem
                                v-for="(value, index) in dropdownStatusList"
                                :name="value.name"
                                :selected="value.name == tableParams.dropDownStatus"
                                :key="index"
                                >{{ value.value }}</DropdownItem
                            >
                        </DropdownMenu>
                    </Dropdown>

                    <!-- <quota @onIndicatorList="onIndicatorList" type="ad" w="4.5rem"></quota>
                    <button class="header-button-ghost" @click="onClickDown">
                        <span class="header-button-ghost-span">下载</span>
                    </button>  -->
                    <!-- 刷新 -->
                    <button
                        class="header-button-ghost refresh-btn"
                        @click="getCampaignList(false)"
                        title="刷新"
                        style="margin: 0"
                    >
                        <i class="icon icon-refresh"></i>
                    </button>
                </div>
            </div>
        </header>
        <!-- 顶部header模块 -->
        <!-- 主体section模块 -->
        <section slot="section" class="c-body-section">
            <!-- 表格 -->
            <!-- <c-table
                @itemChange="confirmItemBudget"
                type="creative"
                :summary="summary"
                :tableDefaultIndicator="tableDefaultIndicator"
                :originList="originData"
                :tableParams.sync="tableParams"
                :indicatorList="indicatorList"
                @check="onSaveSelected"
                @change="getCampaignList(false)"
            /> -->
            <el-table
            :data="originData"
            style="width: 100%;border:1px solid #EBEEF5"
            >   
                <el-table-column fixed prop="code" label="ID" width="70"> </el-table-column>
                <el-table-column fixed prop="name" label="广告" width="180">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <!--  -->
                            <span>{{scope.row.name}}</span>
                            <span class="bg-ivu-tag">{{sizeType[scope.row.sizeType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed prop="email" label="账号名（邮箱）" width="150"> </el-table-column>
                <el-table-column prop="seriesName" label="广告系列" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <!--  -->
                            <span>{{scope.row.seriesName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="campaignName" label="广告组" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <!--  -->
                            <span>{{scope.row.campaignName}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="install" label="状态" width="80">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <el-switch
                                @change="TableGZState(scope.row)"
                                v-model="scope.row.status"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                :active-value="1"
                                :inactive-value="0">
                            </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="imgUrl" label="广告图" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                        <el-image 
                            fit="cover"	
                            style="width: 100px;"
                            :src="scope.row.imgUrl"
                            :preview-src-list="srcList"
                            @click="()=>{srcList = [],srcList.push(scope.row.imgUrl)}">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="dropDownStatus" label="投放状态" width="120">
                    <template slot-scope="scope" v-if="scope.$index != 0">
                            <span v-if="scope.row.dropDownStatus" style="color:green">已投放</span>
                            <span v-else style="color:red">未投放</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bid" label="竞价请求量" width="120"> </el-table-column>
                <el-table-column prop="imp" label="展现量" width="120"> </el-table-column>
                <el-table-column prop="click" label="点击量" width="120"> </el-table-column>
                <el-table-column prop="ctr" label="CTR" width="120"> </el-table-column>
                <el-table-column prop="cpa" label="CPA" width="120"> </el-table-column>
                <el-table-column prop="cpc" label="CPC" width="120"> </el-table-column>
                <el-table-column prop="cpm" label="CPM" width="120"> </el-table-column>
                <el-table-column prop="calculateImp" label="补/扣量后的clickimp数" width="140"> </el-table-column>
                <el-table-column prop="calculateClick" label="补/扣量后的click数" width="150"> </el-table-column>
                <el-table-column prop="calculateSpends" label="补/扣量后的花费数" width="140"> </el-table-column>
                <el-table-column prop="calculateCpc" label="补/扣量后的cpc" width="140"> </el-table-column>
                <el-table-column prop="calculateCpm" label="补/扣量后的cpm" width="140"> </el-table-column>
                <!-- <el-table-column prop="install" label="安装量" width="120"> </el-table-column>
                <el-table-column prop="installRate" label="安装率" width="100"> </el-table-column> -->
                <el-table-column prop="deal" label="转化量" width="120"> </el-table-column>
                <el-table-column prop="dealRate" label="转化率" width="100"> </el-table-column>
                <el-table-column prop="ecpm" label="eCPM" width="120"> </el-table-column>
                <el-table-column prop="amount" label="收益" width="120"> </el-table-column>

                <el-table-column
                    fixed="right"
                    label="操作"
                    width="120">
                <template slot-scope="scope"  v-if="scope.$index != 0">
                    <el-button @click.native.prevent="onchangeItem('edit',scope.row.code,scope.row.publisherId)" type="text" size="small"> 编辑 </el-button>
                </template>

                </el-table-column>
        </el-table>


        </section>
        <!-- 预算 -->
        <cBudgetSimple :show.sync="show" @save="confirmBudget"></cBudgetSimple>
        <!-- 日期 -->
        <Modal v-model="show.date" width="500" class="c-modal" @on-ok="submitDate">
            <p slot="header" class="modal-header">修改日期</p>
            <div class="modal-detail">
                <div class="modal-row">
                    <span class="modal-row-label">日期：</span>
                    <!-- 日期选择 -->
                    <date-picker
                        :value="date"
                        class="modal-row-input"
                        type="daterange"
                        placement="bottom-end"
                        placeholder="选择日期，默认不限"
                        style="font-size: 0.1rem"
                        @on-change="onDateChange"
                    />
                </div>
            </div>
        </Modal>
        <!-- 日期 -->
        <!-- 时段 -->
        <Modal v-model="show.time" width="650" class="c-modal" @on-ok="submitTime">
            <p slot="header" class="modal-header">修改时段</p>
            <div class="modal-detail">
                <div class="modal-row">
                    <span class="modal-row-label">时段：</span>
                    <i-switch size="large" v-model="show.targetTime">
                        <span slot="open">指定</span>
                        <span slot="close">不限</span>
                    </i-switch>
                </div>
                <tiem-zone
                    @timezone="onTargetTimeChange"
                    :timezone="targetTime"
                    :disabled="!show.targetTime"
                ></tiem-zone>
            </div>
        </Modal>
        <!-- 时段 -->
        <footer slot="footer" class="c-body-footer">
            <!-- 分页器 -->
            <c-page
                :table-params.sync="tableParams"
                :page-bean.sync="pageBean"
                class="foot-row"
                @on-change="getCampaignList(false)"
                @on-page-size-change="getCampaignList(true)"
            />
        </footer>
    </div>
</template>
<script>
import common from '@/utils/common';
import mixins from '@/mixins/index.js';
import tiemZone from '@/components/commons/Drag.vue';
import cBody from '@/components/commons/cBody.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import quota from '@/components/commons/quota.vue';
import cPage from '@/components/commons/cPage.vue';
import cTable from '@/components/commons/manageTable.vue';
import cBudgetSimple from '@/components/commons/cBudgetSimple.vue';
import cBid from '@/components/commons/cBid.vue';
import tablelist from '@/server/tablelist.js';
import { mapState } from 'vuex';
export default {
    name: 'managementad',
    mixins: [mixins],
    components: {
        tiemZone,
        cTable,
        cBudgetSimple,
        cBid,
        cBody,
        cDatePicker,
        quota,
        cPage,
    },
    props: {
        tagCreative: {
            type: Number,
        },
    },
    data() {
        return {
            //批量修改预算
            totalBudget: { totalBudget: '', totalImp: '', totalClick: '' },
            // dailyBudget: { dailyBudget: "", dailyImp: "", dailyClick: "" },
            date: [], //批量修改时期
            targetTime: '', //批量修改时段
            bidPrice: '', //批量修改出价价格
            //显示控制器
            show: {
                bidPrice: false,
                date: false,
                time: false,
                budget: false,
                targetTime: false,
                totalBudget: false,
                dailyBudget: false,
            },
            //推广列表数据
            originData: [],
            //分页对象
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 1,
            },
            //获取推广列表的参数
            tableParams: {
                // page: 1,
                // pageSize: 10,
                // startDate: this.mixinGetDate('today'),
                // endDate: this.mixinGetDate('today'),
                // status: '',
                // dropDownStatus: '',
                // keyword: '',
                // orderName: 'id',
                // orderType: 'desc',
                page: 1,
                pageSize: 10,
                startDay: this.mixinGetDate('today'),
                endDay: this.mixinGetDate('today'),
                status: '',
                dropDownStatus: '',
                offerBundleStatus: '',
                keyword: '',
                orderName: 'code',
                orderType: 'desc',
                countries: '',
                dimension:'campaign_offer',
                publisherName:"",
            },
            sizeType: {
                1: '300x250',
                2: '1200x628',
                3: '720x1280',
                4: '1280x720',
                5: '320x50',
                6: '320x480',
                7: '1200x627',
                8: '320x200',
                9: '1200x628',
                10: '640x360',
            },

            //汇总
            summary: {},
            //显示创意列表
            currentOffer: '',
            //自动刷新开关,默认不打开
            autoRefresh: false,
            //自动刷新定时器
            autoInterval: '',

            url: '',
            srcList: ['1111'],
        };
    },
    watch: {
        tagCreative: {
            handler(value) {
                if (!value) this.originData.map((itetagCreativem) => (item.selected = false));
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState({
            dropdownStatusValue: (state) => state.promotionManagement.dropdownStatusValue,
            dropdownStatusList: (state) => state.promotionManagement.dropdownStatusList,
            statusText: (state) => state.promotionManagement.statusText,
            statusColor: (state) => state.promotionManagement.statusColor,

            statusValue: (state) => state.promotionManagement.adminstatusValue,
            statusList: (state) => state.promotionManagement.adminstatusList,
        }),
        //已选择
        selectedCount() {
            return this.originData.filter((item) => item.selected).length;
        },
        //已选择数组
        selectedList() {
            return this.originData.filter((item) => item.selected);
        },

        //全选
        selectedAll() {
            return this.originData.length ? this.originData.every((item) => item.selected) : false;
        },
        // 指标栏是否默认
        isDefaultIndicator() {
            return (
                !this.indicatorArr.some((item) => item.selected != item.isDefault) ||
                this.indicatorArr.every((item) => !item.selected)
            );
        },
    },
    mounted() {
        // if (this.$store.state.manageData.group && this.$store.state.manageData.group.tableParams) {
        //     this.tableParams = {
        //         ...this.$store.state.manageData.group.tableParams,
        //     };
        //     this.tableParams.status = '';
        //     this.tableParams.keyword = '';
        //     this.tableParams.page = 1;
        //     this.tableParams.pageSize = 10;
        //     this.tableParams.orderName = 'id';
        //     this.tableParams.orderType = 'desc';
        // } else if (this.$store.state.manageData.series) {
        //     if (this.$store.state.manageData.series.tableParams) {
        //         this.tableParams = {
        //             ...this.$store.state.manageData.series.tableParams,
        //         };
        //     }
        //     this.tableParams.status = '';
        //     this.tableParams.keyword = '';
        //     this.tableParams.page = 1;
        //     this.tableParams.pageSize = 10;
        //     this.tableParams.orderName = 'id';
        //     this.tableParams.orderType = 'desc';
        // }
        // if (this.$store.state.manageData.ad && this.$store.state.manageData.ad.indicatorList) {
        //     this.indicatorList = {
        //         ...this.$store.state.manageData.ad.indicatorList,
        //     };
        // }
        this.getCampaignList(true);
    },
    beforeDestroy() {
        clearInterval(this.autoInterval);
    },
    methods: {
        TableGZState(item){
            console.log('item',item)
            this.confirmItemBudget(item)
        },  

        /**
         * @description 表格item操作
         * @param item
         */
         onchangeItem(action, id,publisherId) {
            let type = 'creative'
            console.log(action, id)
            window.open(`${location.origin}/#/newPromition?type=${type}&action=${action}&id=${id}&publisherId=${publisherId}`,'_self');
        },

        // 取消全选
        //全选
        onReSelectedAll() {
            this.originData.forEach((item) => (item.selected = false));
            this.onSaveSelected();
        },
        /*
         * @description 确认修改单项参数
         */
        async confirmItemBudget(item) {
            console.log('item', item.data);
            const params = [
                {
                    id: item.code,
                    status: item.status,
                },
            ];
            console.log(params);
            const res = await this.$axios.post(this.$port.seriesTable.offerBatchUpdate, params);

            this.afterSubmit(res);
        },
        /*
         * @description 获取指标列表更新
         */
        onIndicatorList(data) {
            this.indicatorList = this.deepClone(data);
        },
        onSaveSelected() {
            this.$store.dispatch('mangeData', {
                name: 'ad',
                value: {
                    selectCount: this.originData.filter((item) => item.selected).length,
                    selectArray: this.originData.filter((item) => item.selected),
                },
            });
        },
        /*
         * @description 获取推广数据
         * @param isInit:boolean 是否初始化页数
         */
        async getCampaignList(isInit) {
            if (isInit) this.tableParams.page = 1;
            this.currentOffer = '';
            //获取表格数据 -获取汇总数据
            let params = { ...this.tableParams };
            // if (this.$store.state.manageData.series && this.$store.state.manageData.series.selectArray) {
            //     let idArr = [];
            //     this.$store.state.manageData.series.selectArray.forEach((item) => idArr.push(item.id));
            //     params.seriesIds = idArr.join(',');
            // }
            // if (this.$store.state.manageData.group && this.$store.state.manageData.group.selectArray) {
            //     let idGroupArr = [];
            //     this.$store.state.manageData.group.selectArray.forEach((item) => idGroupArr.push(item.id));
            //     params.campaignIds = idGroupArr.join(',');
            // }
            // if(sessionStorage.getItem('Selection_series') && JSON.parse(sessionStorage.getItem('Selection_series')).length > 0){
            //     let idArr = JSON.parse(sessionStorage.getItem('Selection_series'));
            //     params.seriesIds = idArr.join(',');
            // }
            if(sessionStorage.getItem('Selection_Campaign') && JSON.parse(sessionStorage.getItem('Selection_Campaign')).length > 0){
                let idArr = JSON.parse(sessionStorage.getItem('Selection_Campaign'));
                params.parentIds = idArr.join(',');
            }

            const resList = await this.$axios.get(this.$port.seriesTable.adList, { params });
            if (resList.data.pageBean) {
                this.pageBean = resList.data.pageBean;
            }
            if (resList.data.list) {
                this.originData = resList.data.list;
            //     this.summary = resList.data.list[0];
            //     resList.data.list = resList.data.list.filter((item, index) => index > 0);
            //     this.originData = resList.data.list.map((item) => {
            //         item.selected = false;
            //         if (
            //             this.$store.state.manageData.series.selectArray &&
            //             this.$store.state.manageData.series.selectArray.length > 0
            //         ) {
            //             this.$store.state.manageData.series.selectArray.forEach((ari) => {
            //                 if (ari.id === item.id) {
            //                     item.selected = true;
            //                 }
            //             });
            //         }
            //         //推广的国家定向
            //         if (!item.countries && item.noncountries) {
            //             item.countryTag = this.setCountryTag(item.noncountries, 2);
            //             item.countryType = 'black';
            //         } else {
            //             item.countryTag = this.setCountryTag(item.countries, 2);
            //             item.countryType = 'white';
            //         }

            //         item.normalOffers = [];
            //         item.deleteOffers = [];
            //         item.showDeleteOffers = false;
            //         if (item.offers && item.offers.length) {
            //             // 格式化offer定向国家数据
            //             item.offers.forEach((cell) => {
            //                 cell.imgUrl = cell.imgUrl.split(',')[0];
            //                 if (cell.status == 1) item.normalOffers.push(cell);
            //                 else item.deleteOffers.push(cell);
            //                 cell.countryTag = this.setCountryTag(cell.countries, 3);
            //             });
            //         }
            //         return item;
            //     });
            }
        },
        /**
         * @desc: 状态筛选
         * @param {String} name: 选择的状态名
         * @param {String} value: 选择的状态值
         */
        changeStatus(name, value) {
            this.$set(this.tableParams, name, value);
            this.getCampaignList(true);
        },
        /**
         * @description 设置国家数组
         * @param countries:string 国家字符串
         * @param length:number 最大长度
         * @return string[] 国家数组
         */
        setCountryTag(countries, length) {
            if (!countries) countries = 'ALL';
            let countryTag = countries.split(',');
            if (countryTag.length > length) countryTag = [...countryTag.filter((a, i) => i < length - 1), '....'];
            return countryTag;
        },
        /**
         * @description 点击批量操作时
         * @param value:number or string 批量操作索引
         */
        onChangeBatchType(value) {
            if (this.selectedCount < 1) {
                this.$Message.warning({
                    content: '请先选择要批量操作的推广',
                    duration: 1.5,
                });
            } else {
                if (value == '出价') this.show.bidPrice = true; //打开出价
                if (value == '预算') this.show.dailyBudget = true; //打开预算
                if (value == '日期') this.show.date = true; //打开时期
                if (value == '时段') this.show.time = true; //打开时段
                if (value == '开启') this.batchUpdate(1); //批量开启
                if (value == '停止') this.batchUpdate(0); //批量停止
                if (value == '还原') this.batchUpdate(0); //批量还原
                if (value == '归档') this.batchUpdate(3); //批量归档
            }
        },
        /**
         * 批量更新状态
         * @param status:string or number 要更新的状态
         */
        async batchUpdate(status) {
            const campaignStatuss = this.originData
                .filter((item) => item.selected)
                .map((item) => ({
                    id: item.id,
                    status: status,
                }));
            const res = await this.$axios.post(this.$port.seriesTable.offerBatchUpdate, campaignStatuss);
            if (res.status == 200) {
                this.getCampaignList();
                this.$Message.success({
                    content: '修改成功',
                    duration: 2,
                });
                this.currentOffer = '';
            } else {
                this.$Message.error({
                    content: res.message,
                    duration: 3,
                });
            }
        },
        /*
         * @description 限制只能输入数字
         * @param event:obj 事件对象
         */
        onInputNumber(event) {
            this.mixinRegNum(event, -1);
        },
        /**
         * @description 修改日期
         * @param event:obj 事件对象
         */
        onDateChange(date) {
            this.date = [...date];
        },
        /*
         * @description 修改时段字符串
         * @param timeStr:string 时段字符串
         */
        onTargetTimeChange(timeStr) {
            this.targetTime = timeStr;
        },
        /**
         * @description 确认预算
         */
        confirmBudget(value) {
            this.show.dailyBudget = false;
            let arr = [];
            this.selectedList.map((item) => {
                const obj = {
                    id: item.id,
                    dailyBudget: value,
                };
                arr.push(obj);
            });
            //如果日预算为0
            if (!this.dailyBudget && this.dailyBudget !== null) {
                this.submitBudget(arr);
            } else {
                this.$Message.error({ content: '修改失败', duration: 1.5 });
            }
        },
        /**
         * @description 提交修改日期
         */
        async submitDate() {
            let arr = [];
            this.selectedList.forEach((item, index) =>
                arr.push({
                    id: item.id,
                    startDay: this.date[0],
                    endDay: this.date[1],
                })
            );
            const params = arr;
            const res = await this.$axios.post(this.$port.seriesTable.offerBatchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @description 报表下载
         */
         onClickDown() {
            const params = Object.assign({}, this.tableParams);
            params.rd = new Date().getTime();
            let queryString = `${this.$port.globalReport.downloadAdmin}?`;
            for (let i in params) {
                queryString += `${i}=${params[i]}&`;
            }
            
            window.location.href = queryString;
        },
        /**
         * @description 提交预算
         * @param params:obj 提交的参数
         */
        async submitBudget(params) {
            const res = await this.$axios.post(this.$port.seriesTable.offerBatchUpdate, params);
            this.afterSubmit(res);
        },
        /**
         * @description 提交修改时段
         */
        async submitTime() {
            const params = {
                campaigns: this.selectedList.map((item, index) => ({
                    id: item.id,
                    targetTime: this.show.targetTime ? this.targetTime : '',
                })),
            };
            const res = await this.$axios.post(this.$port.manager.batchUpdateCampaign, params);
            this.afterSubmit(res);
        },
        /**
         * @description 批量操作后回调
         * @param res:obj 请求回调对象
         */
        afterSubmit(res) {
            if (res.status == 200) {
                this.$Message.success({ content: '修改成功', duration: 1.5 });
                this.getCampaignList(false);
            } else {
                this.$Message.error({ content: '修改失败', duration: 1.5 });
            }
        },
    },
};
</script>
<style lang="scss">
@import 'src/style/frequently.scss';
@import 'src/style/cModal.scss';

#ad-detail {
    .header-search {
        width: 3rem !important;
    }
    #c-body .c-body-section .c-body-table .table-tr {
        .table-td-primary {
            min-width: 0.4rem;
        }

        .table-td-primary:nth-of-type(1) {
            padding-right: 0;
            padding-left: 0.2rem;
        }
        //展示删除创意按钮
    }

    .edit-box {
        justify-content: flex-end;
        display: flex;
        width: 2.5rem;
        position: relative;
        align-items: center;
        .edit {
            width: 2.5rem;
            height: 100%;
            display: flex;
            align-items: center;
            position: absolute;
            flex: 1;
            .close-btn {
                cursor: pointer;
                position: absolute;
                right: 1.2rem;
            }
        }
    }
}
.bg-ivu-tag {
    padding: 0 0.04rem;
    margin: 0 0.02rem;
    font-size: 0.08rem;
    line-height: 0.18rem;
    height: 0.18rem;
    top: -1px;
    position: relative;
    background: #2D8cF0;
    color:#fff;
    display:inline-flex;
    border-radius:3px;
}


</style>



// WEBPACK FOOTER //
// src/view/PromotionManagement/Creative.vue